module.exports = __webpack_public_path__ + "static/icon-f836ec0cd2e2b6904ac1d1f587d8ae94.png";